import React from 'react'
import {
  EnterpriseSummary,
  RelatedEnterprise,
} from '../../clients/kyousou_api_client'

type EnterpriseData = EnterpriseSummary | RelatedEnterprise

interface RelatedEnterprisesSectionProps {
  relatedEnterprises: EnterpriseData[]
  title?: string
  className?: string
  onEnterpriseClick?: (enterprise: EnterpriseData) => void
}

/**
 * 関連企業一覧を表示する共通コンポーネント
 */
const RelatedEnterprisesSection: React.FC<RelatedEnterprisesSectionProps> = ({
  relatedEnterprises,
  title = '関連企業',
  className = 'border border-main-lightgray rounded p-4',
  onEnterpriseClick,
}) => {
  // 企業ロゴの表示
  const renderLogo = (enterprise: EnterpriseData) => (
    <div className="w-10 h-10 bg-main-lightgray rounded-full flex items-center justify-center border border-main-lightgray flex-shrink-0">
      {enterprise.logoUrl ? (
        <img
          src={enterprise.logoUrl}
          alt={`${enterprise.name}ロゴ`}
          className="w-full h-full object-cover rounded-full"
        />
      ) : (
        <span className="text-main-red text-xs font-bold">
          {enterprise.name.slice(0, 3)}
        </span>
      )}
    </div>
  )

  // 企業名と業種の情報表示
  const renderEnterpriseInfo = (enterprise: EnterpriseData) => (
    <div>
      <p className="font-bold text-main-black text-sm">{enterprise.name}</p>
      <p className="text-xs text-main-darkgray">
        {enterprise.industryParentCode?.value || '業種不明'}
      </p>
    </div>
  )

  // 関連企業1件分のアイテム表示
  const renderEnterpriseItem = (enterprise: EnterpriseData, index: number) => (
    <div
      key={enterprise.id || index}
      className={`flex items-center justify-between p-3 transition-colors ${
        onEnterpriseClick ? 'hover:bg-main-lightgray cursor-pointer' : ''
      }`}
      onClick={() => onEnterpriseClick?.(enterprise)}
    >
      <div className="flex items-center gap-3">
        {renderLogo(enterprise)}
        {renderEnterpriseInfo(enterprise)}
      </div>
      <span className="material-icons text-main-black">chevron_right</span>
    </div>
  )

  // 関連企業データがない場合の表示
  if (!relatedEnterprises?.length) {
    return (
      <div className={className}>
        <h3 className="text-lg font-bold mb-4">{title}</h3>
        <div className="text-center text-main-darkgray py-4">
          関連企業情報がありません
        </div>
      </div>
    )
  }

  // 関連企業リストの表示
  return (
    <div className={className}>
      <h3 className="text-lg font-bold mb-4">{title}</h3>
      <div className="space-y-4">
        {relatedEnterprises.map((enterprise, index) =>
          renderEnterpriseItem(enterprise, index)
        )}
      </div>
    </div>
  )
}

export default RelatedEnterprisesSection
